import React from 'react';
import { AlertCircle } from 'lucide-react';

export const ErrorAlert = ({ error, type = 'error' }) => {
  if (!error) return null;

  const bgColor = type === 'error' ? 'bg-red-50' : 'bg-amber-50';
  const borderColor = type === 'error' ? 'border-red-200' : 'border-amber-200';
  const textColor = type === 'error' ? 'text-red-800' : 'text-amber-800';
  const iconColor = type === 'error' ? 'text-red-600' : 'text-amber-600';

  return (
    <div className={`${bgColor} ${borderColor} rounded-xl border p-4 shadow-sm`}>
      <div className="flex items-start gap-3">
      <AlertCircle className={`w-5 h-5 ${iconColor} flex-shrink-0`} />
      <p className={`${textColor} text-sm font-medium`}>{error}</p>
      </div>
    </div>
  );
};
